// Browser clients may initiate only close code 1000 or application-defined codes from 3000
// through 4999. Keep generation rejection in the private-use range instead of the server-only
// policy-violation code 1008.
export const WEBSOCKET_GENERATION_MISMATCH_CLOSE_CODE = 4008;
